module.exports = __webpack_public_path__ + "static/apk-file-badge-49830dd505335ba8bfccbfe533bcd638.png";